export const BANNER_PLACEMENT = {
  mainPage: 'BANNER_PLACEMENT_MAIN_PAGE',
  restaurantPage: 'BANNER_PLACEMENT_RESTAURANT_PAGE',
} as const;

export const BANNER_KIND = {
  product: 'BANNER_TYPE_PRODUCT',
  restaurant: 'BANNER_TYPE_RESTAURANT',
} as const;
